import { useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { captureException } from "@sentry/react";

import BillingHistory from "./BillingHistory";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import { AWS_ISSUED_INVOICES_URL } from "constants";

export default () => {
  const [page, setPage] = useState(1);

  // Fetch data
  const GET_BILLING_HISTORY = gql`
    query GetBillingHistory($page: Int!) {
      billingHistory(page: $page) {
        payments {
          id
          created_at
          provider
          item
          amount
          tax
          invoice_number
          invoice_filename
        }
        numOfResults
      }
    }
  `;

  const { data, error } = useQuery(GET_BILLING_HISTORY, {
    variables: {
      page,
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("fetching billing history error", error);
    captureException(error);
  }

  //console.log({ data });

  const onDownloadClick = (filename) => {
    const fileUrl = AWS_ISSUED_INVOICES_URL + filename;

    window.open(fileUrl, "_blank");
  };

  const limit = 10;

  if (data) {
    if (data.billingHistory.numOfResults > 0)
      if (page > Math.ceil(data.billingHistory.numOfResults / limit))
        setPage(1);
  }

  const paginate = (where) => {
    if (where === "previous") setPage((prevState) => prevState - 1);
    if (where === "next") setPage((prevState) => prevState + 1);
  };

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="435px" />
        </LoadingBox>
      )}
      {data && (
        <BillingHistory
          data={data}
          page={page}
          limit={limit}
          paginate={paginate}
          onDownloadClick={onDownloadClick}
        />
      )}
    </>
  );
};
